(function () {
  'use strict';

  angular
    .module('web2print.landing')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig ($stateProvider, $urlRouterProvider) {
    console.log('Landing routes');
    $stateProvider
      .state('main.landing', {
        url: '/information',
        templateUrl: 'components/landing/landing.html',
        controller: 'LandingController',
        controllerAs: 'ctrl',
        onEnter: function () {
          if (web2print.env.stage !== 'dev') {
            window.open(web2print.env.siteV2Url,'_self');
          }
        }
      })
      .state('main.admail', {
        url: '/advertisment',
        templateUrl: 'components/landing/landing.html',
        controller: 'LandingController',
        controllerAs: 'ctrl',
        onEnter: function () {
          if (web2print.env.stage !== 'dev') {
            window.open(web2print.env.siteV2Url,'_self');
          }
        }
      });
  }

})();
